import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        {/* Section 1: Hero Banner */}
        <section className="hero-banner">
          <div className="hero-background">
            <img
              src="/main/main1.webp"
              alt="Enriching the Bond Between People & Their Pets"
            />
          </div>
          <div className="hero-content">
            <h1 className="hero-title">
              Enriching the Bond Between
              <br />
              People &amp; Their Pets
            </h1>
            <p className="hero-subtitle">
              Innovating across dog and cat toys, kennels, feeding, food
              storage,
              <br />
              treats, chews and more.
            </p>
            <div className="hero-buttons">
              <Link to="/shop" className="btn-hero" onClick={toTop}>
                SHOP DOG ESSENTIALS
              </Link>
              <Link to="/shop" className="btn-hero" onClick={toTop}>
                SHOP CAT ESSENTIALS
              </Link>
            </div>
          </div>
        </section>

        {/* Section 2: Promo Banner and Intro Text */}
        <section className="promo-section">
          <div className="promo-banner-container">
            <Link to="/shop" onClick={toTop}>
              <img
                src="/brand/fetch-promo.svg"
                alt="Petoutlet active play collection - Play more, fetch more"
                className="promo-banner-img"
              />
            </Link>
          </div>

          <div className="intro-text-container">
            <h2 className="intro-title">Top-Rated Essentials for Every Pet</h2>
            <p className="intro-description">
              Explore customer-favorite picks designed to make pet parenting
              easier from durable
              <br />
              crates and fetch toys, airtight food storage, and waste solutions.
            </p>
          </div>
        </section>

        {/* Section 3: Hot Right Now Products */}
        <section className="hot-products-section">
          <div className="container">
            <h2 className="section-title">Hot Right Now</h2>
            <div className="products-grid">
              {productData.slice(0, 4).map((product) => (
                <div className="product-card" key={product.id}>
                  <div className="product-image-container">
                    <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                      <img src={product.image} alt={product.name} />
                    </Link>
                  </div>
                  <div className="product-info">
                    <Link
                      to={`/shopDetails/${product.id}`}
                      onClick={toTop}
                      className="product-name"
                    >
                      {product.name}
                    </Link>

                    <div className="product-price">
                      {product.id === 1 ? "From " : ""}${product.price}
                    </div>
                    <Link
                      to={`/shopDetails/${product.id}`}
                      className="btn-shop-now"
                      onClick={toTop}
                    >
                      SHOP NOW
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section 4: Trusted Brands Intro */}
        <section className="trusted-brands-section">
          <div className="container text-center">
            <h2 className="section-title">Shop Trusted Petoutlet Brands</h2>
            <p className="brands-description">
              Discover Petoutlet-designed essentials for active play, fresh
              food storage, and comfortable travel
              <br />
              for playtime, mealtime, travel, and more. Designed for dogs, cats,
              and pet parents
              <br />
              who expect the best.
            </p>
          </div>
        </section>

        {/* Section 5: Brand Features Grid */}
        <section className="brand-features-section">
          <div className="container">
            <div className="brands-grid">
              {/* Feature 1: Active Play */}
              <div className="brand-card">
                <Link to="/shop" className="brand-image-link" onClick={toTop}>
                  <div className="image-wrapper">
                    <img
                      src="/img/petoutlet-01-front.png"
                      alt="Petoutlet active play fetch ball"
                    />
                    <div className="brand-tag">#activeplay</div>
                  </div>
                </Link>
                <div className="brand-info">
                  <h3 className="brand-title">
                    High Performance Toys for All Types of Play
                  </h3>
                  <p className="brand-desc">
                    Explore toys that fuel your dog's need to chase, retrieve,
                    and play with
                    <br />
                    purpose on land, water, or indoors, keep your dog
                    entertained year-round.
                  </p>
                </div>
              </div>

              {/* Feature 2: Fresh Storage */}
              <div className="brand-card">
                <Link to="/shop" className="brand-image-link" onClick={toTop}>
                  <div className="image-wrapper">
                    <img
                      src="/img/petoutlet-07-front.png"
                      alt="Petoutlet airtight food storage lid"
                    />
                    <div className="brand-tag">#freshstorage</div>
                  </div>
                </Link>
                <div className="brand-info">
                  <h3 className="brand-title">
                    Airtight Pet Food Storage Solutions
                  </h3>
                  <p className="brand-desc">
                    Keep dry pet food fresh and pests out with airtight, durable
                    food
                    <br />
                    storage trusted by pet parents for long-lasting freshness.
                  </p>
                </div>
              </div>

              {/* Brand 3: Petoutlet */}
              <div className="brand-card">
                <Link to="/shop" className="brand-image-link" onClick={toTop}>
                  <div className="image-wrapper">
                    <img
                      src="/img/petoutlet-04-front.png"
                      alt="Petoutlet ventilated travel kennel"
                    />
                    <div className="brand-tag">#safetravel</div>
                  </div>
                </Link>
                <div className="brand-info">
                  <h3 className="brand-title">
                    Durable Kennels for Home and Travel
                  </h3>
                  <p className="brand-desc">
                    Explore Petoutlet kennels—comfortable, ventilated, and
                    travel-ready carriers made to
                    <br />
                    the USA to protect pets at home and on the go.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 6: Shop by Pet Type */}
        <section className="shop-by-pet-section">
          <div className="container text-center">
            <h2 className="section-title text-white">Shop by Pet Type</h2>
            <p className="pet-type-description text-white">
              Explore curated products for dogs &amp; cats, designed to support
              their comfort, play,
              <br />
              and care.
            </p>

            <div className="pet-type-grid">
              {/* Dogs */}
              <div className="pet-card">
                <Link to="/shop" onClick={toTop}>
                  <img src="/main/main4-1.webp" alt="Shop for Dogs" />
                  <div className="pet-label">Dogs</div>
                </Link>
              </div>

              {/* Cats */}
              <div className="pet-card">
                <Link to="/shop" onClick={toTop}>
                  <img src="/main/main4-2.webp" alt="Shop for Cats" />
                  <div className="pet-label">Cats</div>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Section 7: Video Banner (The Petoutlet Story) */}
        <section className="video-banner-section">
          <div className="video-container">
            <img
              src="/main/main1.webp"
              alt="Pet parent spending time with a dog and cat"
              className="background-video"
            />

            {/* Dark overlay for text readability */}
            <div className="video-overlay"></div>

            <div className="video-content-wrapper">
              <div className="video-content">
                <div className="logo-badge">
                  <img src="/brand/petoutlet-logo.svg" alt="Petoutlet" />
                </div>
                <h2 className="video-title">
                  Designed Around
                  <br />
                  Real Pet Routines
                </h2>
                <p className="video-description">
                  Petoutlet selects thoughtfully designed products that bring
                  <br />
                  comfort, safety, and joy to pets and their people, generation
                  <br />
                  every day.
                </p>
                <Link to="/about" className="btn-story" onClick={toTop}>
                  THE PETOUTLET STORY
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Section 8: Pet Tips & Insights (Blog) */}
        <section className="blog-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">
                Pet Tips &amp; Insights for Every Stage
              </h2>
            </div>

            <div className="blog-grid">
              {/* Article 1 */}
              <div className="blog-card">
                <Link to="/shop" onClick={toTop}>
                  <div className="blog-image">
                    <img
                      src="/main/main6-1.webp"
                      alt="Best Interactive Puppy Toys and How to Choose"
                    />
                  </div>
                  <div className="blog-content">
                    <h3 className="blog-title">
                      Best Interactive Puppy Toys and How to Choose
                    </h3>
                    <div className="blog-meta">
                      <span className="blog-date">APRIL 17, 2026</span>
                      <span className="blog-comments">0 comments</span>
                    </div>
                  </div>
                </Link>
              </div>

              {/* Article 2 */}
              <div className="blog-card">
                <Link to="/shop" onClick={toTop}>
                  <div className="blog-image">
                    <img
                      src="/main/main6-2.webp"
                      alt="A Guide to Essential Pet Supplies Every Dog and Cat Owner Needs"
                    />
                  </div>
                  <div className="blog-content">
                    <h3 className="blog-title">
                      A Guide to Essential Pet Supplies Every Dog and Cat Owner
                      Needs
                    </h3>
                    <div className="blog-meta">
                      <span className="blog-date">MARCH 26, 2026</span>
                      <span className="blog-comments">0 comments</span>
                    </div>
                  </div>
                </Link>
              </div>

              {/* Article 3 */}
              <div className="blog-card">
                <Link to="/shop" onClick={toTop}>
                  <div className="blog-image">
                    <img
                      src="/main/main6-3.webp"
                      alt="Dog Mental Stimulation Toys for a Calmer, Happier Pet"
                    />
                  </div>
                  <div className="blog-content">
                    <h3 className="blog-title">
                      Dog Mental Stimulation Toys for a Calmer, Happier Pet
                    </h3>
                    <div className="blog-meta">
                      <span className="blog-date">MARCH 19, 2026</span>
                      <span className="blog-comments">0 comments</span>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Section 9: Replacement Parts Banner */}
        <section className="replacement-parts-section">
          <div className="container">
            <div className="replacement-banner">
              <div className="replacement-content">
                <h2 className="replacement-title">
                  Replacement Parts for Pet Gear
                </h2>
                <p className="replacement-description">
                  From kennel doors to hardware, find replacement parts to keep
                  your pet's
                  <br />
                  setup safe, secure, and in top shape.
                </p>
                <Link
                  to="/shop"
                  className="btn-shop-replacement"
                  onClick={toTop}
                >
                  SHOP REPLACEMENT PARTS
                </Link>
              </div>
              <div className="replacement-image">
                <img
                  src="/img/petoutlet-13-angle.png"
                  alt="Replacement Parts for Pet Gear"
                />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
